import React from 'react'
import { Modal, TextStyle } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';

interface Props {
  onCancel: () => void;
  active: boolean;
}

const NoSupportISWModal = (props: Props) => {
  const {
    active, i18n,
    onCancel
  } = props;
  return (
    <Modal
      open={active}
      onClose={onCancel}
      title={i18n.translate('AdminHTML.VariantsDisplay.Modal.noSupportISW_Title')}
      primaryAction={[
        {
          content: i18n.translate('AdminHTML.Common.Action.close'),
          onAction: onCancel
        }
      ]}>
      <Modal.Section>
        <p>
          <TextStyle variation="strong">{i18n.translate('AdminHTML.VariantsDisplay.Modal.noSupportISW_P1')}</TextStyle>
        </p>
        <p style={{ marginTop: 10 }}>
          <TextStyle>{i18n.translate('AdminHTML.VariantsDisplay.Modal.noSupportISW_P2')}</TextStyle>
        </p>
        <p style={{ marginTop: 10 }}>
          <TextStyle variation="strong">{i18n.translate('AdminHTML.VariantsDisplay.Modal.noSupportISW_P3')}</TextStyle>
        </p>
      </Modal.Section>
    </Modal>
  )
}

export default withI18n()(NoSupportISWModal);
